import { computed, inject } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';

/**
 * Composable pour récupérer l'account_id dans le contexte d'un client portal.
 * Priorise l'account_id du portail (contexte public) sur l'account_id de la route (contexte dashboard).
 *
 * @returns {import('vue').ComputedRef<number|null>} L'account_id disponible
 */
export function usePortalAccount() {
  // Injecter l'account_id du portail si disponible (fourni par Index.vue)
  const portalAccountId = inject('portalAccountId', null);

  // Récupérer l'account_id de la route (pour le contexte dashboard)
  const { accountId: routeAccountId } = useAccount();

  // Computed qui retourne l'account_id approprié selon le contexte
  const accountId = computed(() => {
    // Priorité au portalAccountId (contexte client portal public)
    if (portalAccountId?.value) {
      return portalAccountId.value;
    }
    // Sinon utiliser l'accountId de la route (contexte dashboard)
    return routeAccountId.value || null;
  });

  return {
    accountId,
  };
}
